import { userClient } from "@/api/userClient";
import { ListPersonalAttendancePreRangeReq } from "@/pbjs/external/user/user_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  startDate?: string; // 查询的开始时间
  endDate?: string; // 查询的结束时间
  name?: string; // 查询的结束时间
  userGroupIds?: Array<number>; // 查询某用户组的所有员工，如果这个字段有值，那优先过滤这个条件
  email?: string;
  employeeID?: string;
  pageIndex: number;
  pageSize: number;
}
export function listPersonalAttendance(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListPersonalAttendancePreRangeReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setEmployeeid(arg.employeeID);
      request.setStartdate(arg.startDate);
      request.setEnddate(arg.endDate);
      request.setName(arg.name);
      request.setUsergroupidsList(arg.userGroupIds);
      request.setEmail(arg.email);
      // setRank
      let _res = await userClient.listPersonalAttendancePreRange(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function downloadPersonalAttendanceExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new ListPersonalAttendancePreRangeReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setStartdate(arg.startDate);
      request.setEmployeeid(arg.employeeID);
      request.setEnddate(arg.endDate);
      request.setName(arg.name);
      request.setUsergroupidsList(arg.userGroupIds);
      request.setEmail(arg.email);
      // setRank
      let _res = await userClient.downloadPersonalAttendancePreRangeExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
